export default class SubmitProposalHandlerError extends Error {
}
